import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-cmp',
    moduleId: module.id,
    templateUrl: 'user.component.html',
    styleUrls: ['user.component.scss']
})

export class UserComponent implements OnInit{

	constructor()  {
        

    } 

	 public loadDynmicallyScript() {
        
        
         var script2 = document.createElement('script');
        script2.src = "../assets/js/swiper.min.js";
        script2.async =false;
        document.head.appendChild(script2);
        script2.onload = () => console.log("");
        var script = document.createElement('script');
        script.src = "../assets/js/swiper.js";
        script.async =false;
        document.head.appendChild(script);
        script.onload = () => console.log("");
     }
    ngOnInit(){
    	this.loadDynmicallyScript()
    }
}
